import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

/** 获取url **/
export function getRedirectUrl () {
  return request.request({
    url: '/api/cashier/redirectUrl',
    method: 'POST',
    data: { wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken }
  })
}

/** 获取url **/
export function getChannelUserId (redirectData) {
  return request.request({
    url: '/api/cashier/channelUserId',
    method: 'POST',
    data: Object.assign({ wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken }, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount) {
  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: {
      wayCode: wayCode.getPayWay().wayCode,
      token: config.cacheToken,
      amount: amount,
      channelUserId: channelUserIdUtil.getChannelUserId()
    }
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo () {
  return request.request({
    url: '/api/cashier/payOrderInfo',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 取消订单 **/
export function cancelPay () {
  return request.request({
    url: '/api/cashier/cancelPay',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

export function payOrder(token, data) {
  return request.request({
    url: '/api/pay/byOrder/' + token,
    method: 'POST',
    data
  })
}

export function redirectCashier(token) {
  return request.request({
    url: '/api/pay/redirect/order',
    method: 'POST',
    data: {
      token
    }
  })
}

export function getOrderInfo (token) {
  return request.request({
    url: '/api/cashier/orderInfo',
    method: 'POST',
    data: {
      token: token
    }
  })
}

/** 对外快捷支付绑卡页信息（H5 传 token） **/
export function getOpenUpFastPageInfo (data) {
  return request.request({
    url: '/api/open/upfast/pageInfo',
    method: 'POST',
    data
  })
}

/** 实人认证 H5 页订单信息 **/
export function getOpenIdentityPageInfo (data) {
  return request.request({
    url: '/api/open/identity/pageInfo',
    method: 'POST',
    data
  })
}

/** 实人认证 H5 提交三要素 **/
export function submitOpenIdentityVerify (data) {
  return request.request({
    url: '/api/open/identity/h5/verify',
    method: 'POST',
    data
  })
}

/** 实人认证 H5 发起支付 **/
export function submitOpenIdentityPay (data) {
  return request.request({
    url: '/api/open/identity/h5/pay',
    method: 'POST',
    data
  })
}

/** 对外快捷支付 H5 发短（4611） **/
export function openUpFastBindSendSms (ifCode, token, data) {
  return request.request({
    url: `/api/card/bind/${ifCode}/${token}`,
    method: 'POST',
    data
  })
}

/** 对外快捷支付 H5 绑卡确认（4613） **/
export function openUpFastBindConfirm (ifCode, token, data) {
  return request.request({
    url: `/api/card/bind/confirm/${ifCode}/${token}`,
    method: 'POST',
    data
  })
}

export function getCaptcha(token, ifCode, data) {
  return request.request({
    url: `/api/captcha/send/${ifCode}/${token}`,
    method: 'POST',
    data
  })
}

export function preOrder(token, ifCode, data) {
  return request.request({
    url: `/api/pay/preOrder/${ifCode}/${token}`,
    method: 'POST',
    data
  })
}

export function checkOrderStatus(orderNo) {
  return request.request({
    url: '/api/pay/fast-query/' + orderNo,
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

export function pageStay(orderNo) {
  return request.request({
    url: `/api/pay/stay/${orderNo}`,
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}
